export const environment = {
    baseUrl: "https://uat312-api.alfa-sa.co/api/",
    apiVersion: "v1",
    production: true
  };
